import { render, staticRenderFns } from "./base-select-user.vue?vue&type=template&id=23696fe8&scoped=true"
import script from "./base-select-user.vue?vue&type=script&lang=js"
export * from "./base-select-user.vue?vue&type=script&lang=js"
import style0 from "./base-select-user.vue?vue&type=style&index=0&id=23696fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23696fe8",
  null
  
)

export default component.exports